import * as React from 'react';

const SpringBootIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
    <svg fill="none" height={36} viewBox="0 0 38 36" width={38} xmlns="http://www.w3.org/2000/svg" {...props}>
        <path
            d="M37.514 15.9509L30.0249 2.99226C29.3767 1.86715 27.7819 0.943115 26.4779 0.943115H11.515C10.2182
            0.943115 8.61621 1.86715 7.96799 2.99226L0.48628 15.9509C-0.162093 17.076 -0.162093 18.9164 0.48628 
            20.0417L7.96783 33.0076C8.61605 34.1329 10.2108 35.0569 11.5148 35.0569H26.4852C27.7819 35.0569 29.3764 
            34.1329 30.0322 33.0078L37.5137 20.0419C38.1621 18.9166 38.1624 17.076 37.514 15.9509ZM17.3793 
            8.11164C17.3793 7.26219 18.0723 6.56916 18.9218 6.56916C19.7712 6.56916 20.4643 7.26219 20.4643
            8.11164V17.3293C20.4643 18.1789 19.7712 18.8718 18.9218 18.8718C18.0723 18.8718 17.3793 18.1789
            17.3793 17.3293V8.11164ZM18.9218 27.7915C13.1542 27.7915 8.45961 23.0969 8.45961 17.3293C8.46706
            14.0208 10.0319 10.9135 12.6847 8.93133C12.8294 8.82326 12.994 8.74483 13.169 8.70056C13.3441 
            8.65628 13.5262 8.64703 13.7048 8.67334C13.8834 8.69964 14.0551 8.76099 14.21 8.85385C14.3649 
            8.9467 14.4998 9.06925 14.6072 9.21443C14.7153 9.35909 14.7938 9.52369 14.838 9.69876C14.8823
            9.87383 14.8916 10.0559 14.8653 10.2346C14.839 10.4133 14.7776 10.585 14.6848 10.7398C14.5919 
            10.8947 14.4693 11.0297 14.3241 11.1371C10.9038 13.678 10.1885 18.5141 12.7294 21.9344C15.2705 
            25.3549 20.1066 26.0701 23.5269 23.5292C25.4867 22.0761 26.6418 19.7735 26.6418 17.3293C26.6386 
            16.12 26.3525 14.9281 25.8065 13.8491C25.2605 12.77 24.4696 11.8336 23.4971 11.1147C22.886 10.6676
            22.7593 9.80311 23.2064 9.19211C23.6536 8.58094 24.5179 8.45427 25.1291 8.90157C27.8041 
            10.8761 29.3765 14.0059 29.384 17.3293C29.384 23.1044 24.6894 27.7915 18.9218 27.7915Z"
            fill="white"
        />
    </svg>
);
export default SpringBootIcon;
